import { render, staticRenderFns } from "./CompanyMainTab.html?vue&type=template&id=554e346e&scoped=true&"
import script from "./CompanyMainTab.ts?vue&type=script&lang=ts&"
export * from "./CompanyMainTab.ts?vue&type=script&lang=ts&"
import style0 from "./CompanyMainTab.scss?vue&type=style&index=0&id=554e346e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554e346e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
